import { ArrivalScanResponse } from '../services/arrivalScan.endpoints';
import ScannedItemCard from './ScannedItemsList/ScannedItemCard';
import { Inventory as PackageIcon } from '@mui/icons-material';
import ListHeader from './ScannedItemsList/ListHeader';

interface ScannedItemsListProps {
  items: ArrivalScanResponse[];
}

const ScannedItemsList = ({ items }: ScannedItemsListProps) => {
  return (
    <div className='bg-white rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 p-8'>
      <ListHeader totalItems={items.length} />

      <div className='flex flex-col gap-4 max-h-[550px] overflow-y-auto pr-2 pt-8 pb-4'>
        {items.length === 0 ? (
          <div className='py-12 flex flex-col items-center justify-center text-gray-400 opacity-60'>
            <PackageIcon sx={{ fontSize: 48, mb: 1 }} />
            <p className='font-bold uppercase tracking-widest text-[11px]'>Aún no hay pedidos escaneados</p>
          </div>
        ) : (
          items.map((item, index) => (
            <ScannedItemCard
              key={`${item.shippingNumber}-${index}`}
              item={item}
              index={index}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default ScannedItemsList;
